"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var iris_1 = require("iris");
function fetch(store, params) {
    return __awaiter(this, void 0, void 0, function () {
        var key, list, _a, priceDiffer, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    key = JSON.stringify(params);
                    store.commit('SET_LOADING', key);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    _a = lodash_1.map;
                    return [4 /*yield*/, iris_1.client.insurances(mapInsuranceDataReq(params, store.getters['channel']))];
                case 2:
                    list = _a.apply(void 0, [_b.sent(),
                        function (insurance) {
                            return lodash_1.mapKeys(insurance, function (_value, key) {
                                return key === 'id' ? 'code' : key;
                            });
                        }]);
                    if (store.getters['lastFetchRequestKey'] === key) {
                        if (list['messages']) {
                            store.commit('SET_SELECTED_INSURANCE', '');
                            store.commit('SET_LIST', []);
                        }
                        else {
                            store.commit('SET_LIST', lodash_1.sortBy(list, 'price'));
                            priceDiffer = store.getters['priceDiffer'];
                            if (priceDiffer) {
                                store.commit('SET_PRICES_WITH_PRICE_DIFFER');
                            }
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    console.error('error on insurances: ', e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.fetch = fetch;
function updatePrice(store, updatePrice) {
    var priceDiffer = {
        code: store.getters['selection'],
        price: updatePrice.price,
        priceOld: updatePrice.priceOld,
    };
    store.commit('SET_PRICE_DIFFER', priceDiffer);
    store.commit('SET_PRICE', priceDiffer);
}
exports.updatePrice = updatePrice;
function resetStore(store) {
    store.commit('RESET_STATE');
}
exports.resetStore = resetStore;
function selectedInsurance(store, insuranceCode) {
    store.commit('SET_SELECTED_INSURANCE', insuranceCode);
}
exports.selectedInsurance = selectedInsurance;
function setChannel(store, channel) {
    store.commit('SET_CHANNEL', channel);
}
exports.setChannel = setChannel;
// export everything compliant to the vuex specification for actions
exports.default = {
    fetch: fetch,
    selectedInsurance: selectedInsurance,
    setChannel: setChannel,
    updatePrice: updatePrice,
    resetStore: resetStore,
};
// maps the input params to the new InsurancesRequest for iris
function mapInsuranceDataReq(params, channel) {
    var birthdates = __spreadArrays(params.other, [params.buyer]).map(function (param) { return param.birthday; });
    var paxIds = lodash_1.range(1, lodash_1.sum([
        params.cruise.adults,
        params.cruise.juveniles,
        params.cruise.children,
    ]) + 1);
    var cruiseService = {
        id: params.cruise.id,
        paxIDs: paxIds,
        cabin: params.cruise.cabinNumber,
        cabinCategory: params.cruise.cabinCategory,
    };
    var transportAir = params.transportations &&
        params.transportations.length > 0 &&
        params.transportations[0].type === 'AIR';
    var transportRailAndFly = params.transportations &&
        params.transportations.length > 1 &&
        params.transportations[params.transportations.length - 1].type === 'RNF';
    var transportRail = params.transportations &&
        params.transportations.length > 0 &&
        params.transportations[0].type === 'RIT';
    var flightService = {
        id: undefined,
        paxIDs: undefined,
        class: undefined,
        direction: undefined,
    };
    var flightService2 = {
        id: undefined,
        paxIDs: undefined,
        class: undefined,
        direction: undefined,
    };
    if (transportAir) {
        flightService.id = params.transportations[0].code;
        flightService.paxIDs = paxIds;
        flightService.class = params.transportations[0].category;
        flightService.direction = params.transportations[0].direction;
        if (params.transportations.length > 1 &&
            params.transportations[1].type === 'AIR') {
            flightService2.id = params.transportations[1].code;
            flightService2.paxIDs = paxIds;
            flightService2.class = params.transportations[1].category;
            flightService2.direction = params.transportations[1].direction;
        }
    }
    var flightServices = [];
    flightServices.push(flightService);
    if (flightService2.id) {
        flightServices.push(flightService2);
    }
    var trainService = {
        id: undefined,
        paxIDs: undefined,
        startDate: undefined,
        endDate: undefined,
        direction: undefined,
        class: undefined,
    };
    if (transportRail) {
        trainService.id = params.transportations[0].code;
        trainService.paxIDs = paxIds;
        trainService.startDate = params.transportations[0].startDate
            ? params.transportations[0].startDate
            : undefined;
        trainService.endDate = params.transportations[0].endDate
            ? params.transportations[0].endDate
            : undefined;
        trainService.class = params.transportations[0].class;
        trainService.direction = params.transportations[0].directionTrain;
    }
    var rnfService = {
        id: undefined,
        class: undefined,
        direction: undefined,
        paxIDs: undefined,
        startDate: undefined,
        endDate: undefined,
    };
    if (transportRailAndFly) {
        var rnfIndex = params.transportations.length - 1;
        rnfService.id = params.transportations[rnfIndex].code;
        rnfService.paxIDs = paxIds;
        rnfService.class = params.transportations[rnfIndex].class;
        rnfService.direction = params.transportations[rnfIndex].directionTrain;
    }
    return {
        priceModel: params.cruise.priceModel,
        birthdates: birthdates,
        cruises: [cruiseService],
        flights: transportAir ? flightServices : [],
        trains: transportRail ? [trainService] : [],
        railAndFlights: transportRailAndFly ? [rnfService] : [],
        includeCoupleAndFamily: true,
        channel: channel
    };
}
//# sourceMappingURL=actions.js.map